import { parseUrlSafe } from '../../expandedResource/expandedResource.utils.js';

const getOriginUrlWithHash = (url, resourceId, options) => {
  if (!options?.forced && url.includes("#")) {
    return url;
  }
  if (!resourceId) {
    return url;
  }
  const urlObject = parseUrlSafe(url);
  if (!urlObject) {
    return url;
  }
  urlObject.hash = `#${resourceId}`;
  return urlObject.toString();
};

export { getOriginUrlWithHash };
//# sourceMappingURL=getOriginUrlWithHash.js.map
